import React, { useEffect, useState, useContext, useRef } from "react";
import { GlobalContext } from "../contexts/GlobalContext";
import { useLocation, useParams, Outlet } from "react-router-dom";
import {
	PiTrash,
	PiDotsThreeVertical,
	PiUsersFour,
	PiUsersFourFill,
	PiUsersFourLight,
	PiPencilSimple,
} from "react-icons/pi";
import {QuestionDialog, Scrollable, MsHeader, ContentContainer,createDialog,ListItem} from "coaz-ui";
import AddUserGroup from "./AddUserGroup";
import EditUserGroup from "./EditUserGroup";
import client from '../client';
import { IoEaselSharp } from "react-icons/io5";

const UserGroups = () => {
	const { version, setVersion } = useContext(GlobalContext);
	const [userGroups, setUserGroups] = useState([]);
	const [updateAuthority, setUpdateAuthority] = useState(false);
	const [deleteAuthority, setDeleteAuthority] = useState(false);
	const [buttons, setButtons] = useState([]);
	const [itemButtons, setItemButtons] = useState([]);
	const [loading, setLoading] = useState(true);
	const { currentUserId } = useParams();
	const {request,getCurrent,errorMessage} = client;
	const path = useLocation().pathname;

	const onAddUserGroup = () => {
		createDialog({
            title:"Add User Group",
            Component:AddUserGroup,
            version:version,
            setVersion:setVersion
        })
	};

	const onEditUserGroup = (item) => {
		if (!item || !item.id) return;
		createDialog({
            title:"Edit User Group",
			params:{id:item.id},
            Component:EditUserGroup,
            version:version,
            setVersion:setVersion
        })
	};

	const onDeleteUserGroup = (item) => {
		if (!item) return;
		createDialog({
            title:'Delete User Group',
            submitText:"Yes",
            cancelText:"No",
            params:{
                submit:async (e) => {
                        try {
                            await request("DELETE", `user-groups/${item.id}`)
                            return {
                                message: 'Successful',
                                success: true
                            };
                        } catch (error) {
                            return {
                                message: errorMessage(error)
                            };
                        }
                    },
                message:`Are you sure you want to delete ${item.text}?`
            },
            Component:QuestionDialog,
            version:version,
            setVersion:setVersion
        })
	};

	const getUserGroups = async () => {
		await request("GET", "user-groups")
			.then((response) => {
				if (response && response.length) {
					setUserGroups(response);
				} else {
					setUserGroups([]);
				}
			})
			.catch((error) => {
				console.log(error)
				setUserGroups([]);
			});
	};

	const load = async () => {
		!loading && setLoading(true);
		const current = await getCurrent();

		if (!current) return;

		let createAuth = current.authorities.find((auth) => {
			return auth.authority === "USERGROUP:CREATE";
		});
		let updateAuth = current.authorities.find((auth) => {
			return auth.authority === "USERGROUP:UPDATE";
		});
		let deleteAuth = current.authorities.find((auth) => {
			return auth.authority === "USERGROUP:DELETE";
		});

		if (createAuth) {
			setButtons([
				{
					Icon: PiUsersFour,
					name: "Add User Group",
					handler: onAddUserGroup,
				},
			]);
		}

		let itemBtns = [];
		if (updateAuth) {
			itemBtns.push({
				Icon: PiPencilSimple,
				name: "Edit User Group",
				handler: onEditUserGroup,
			});
		}
		if (deleteAuth) {
			itemBtns.push({
				Icon: PiTrash,
				name: "Delete User Group",
				handler: onDeleteUserGroup,
			});
		}
		setItemButtons(itemBtns);

		getUserGroups();
	};

	useEffect(() => {
		load();
	}, [version]);
	return (
		<ContentContainer
			buttons={buttons}
			Icon={PiUsersFourLight}
			text="User Groups"
			scrollable={true}
			background={true}
		>
			{userGroups && userGroups.length > 0 && (
				<div className="flex flex-col w-full h-auto space-y-2">
					{userGroups.map((userGroup, i) => (
						<ListItem
							key={i}
							Icon={PiUsersFourLight}
							item={{ id: userGroup.ref.id, text: userGroup.name }}
							buttons={itemButtons}
						/>
					))}
				</div>
			)}
		</ContentContainer>
	);
};

export default UserGroups;